import React from 'react'
import { Helmet } from "react-helmet"
import { connect } from 'react-redux'
import Chart from "react-apexcharts"
import MainDashboardPagination from '../../../../../../Pagination/MainDashboardPagination'

const DayDashboard = (props) => {
    const FormData = props.kpiData
    const currencyFormatter = props.currencyFormatter
    const numberFormatter = props.numberFormatter
    const CostProfitData = props.costProfitKPIData
    const SalesTrendingData = props.trendingData
    const JHBData = props.jhbData
    const CPTData = props.cptData
    const ProductData = props.productData
    const PageSize = props.pageSize
    const TotalProducts = props.TotalProducts
    const CurrentDate = props.currentDate
    const LoadDayProductSalesList = props.LoadDayProductSalesList
    const MonthProfile = props.MonthProfile
    const YearProfile = props.YearProfile
    const apexChartSeries = (seriesName, seriesData, seriesName1, seriesData1) => 
    (
        [
            {
                name: seriesName,
                data: seriesData,
                type: 'line'
            },
            {
                name: seriesName1,
                data: seriesData1,
                type: 'column'
            }
        ]
    )
    const apexChartDualOptions = (chartId, xaxis, seriesA, seriesB) =>
    (
        {
            chart: {
                id: chartId,
                width: "100%"
            },
            dataLabels: {
                enabled: true,
            },
            stroke: {
                width: [0, 4]
            },
            markers: {
                size: 1
            },
            xaxis: {
                categories: xaxis
            },
            yaxis: [
                {
                    title: {
                        text: seriesA
                    },
                },
                {
                  opposite: true,
                  title: {
                    text: seriesB
                  }
                }
            ],
            colors: ['#1B2850','#FF9F43',],
            stroke: {
                curve: 'smooth'
            },
            dataLabels: {
                enabled: false, 
                style: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: 'black'
                },
                background: {
                    enabled: true,
                    foreColor: 'black',
                    borderRadius: 2,
                    padding: 4,
                    opacity: 0.9,
                    borderWidth: 1,
                    borderColor: '#fff',
                },
            },
            plotOptions: {
                pie: {
                    legend: {
                        position: 'bottom'
                    }
                }
            },
            grid: {
                show: false
            }

        }
    )
    return (
        <>			
			<Helmet>
				<link rel="stylesheet" href="../assets/css/style.css"/>
                <script src="../assets/js/script.js" />
                <script src="../assets/plugins/apexchart/chart-data.js" />
            </Helmet>
            <div>
				<div className="row">
					<div className="col-lg-3 col-sm-6 col-6">
						<div className="dash-widget">
							<div className="dash-widgetimg">
								<span><img src="../../../../../../assets/img/icons/dash1.svg" alt="img"/></span>
							</div>
							<div className="dash-widgetcontent">
								<h5><span>{currencyFormatter.format(FormData['revenue'])}</span> (<span>{(Math.round(FormData['revenue_change']))}%</span>)</h5>
								<h6>Total Revenue</h6>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-sm-6 col-6">
						<div className="dash-widget dash1">
							<div className="dash-widgetimg">
								<span><img src="../../../../../../assets/img/icons/dash2.svg" alt="img"/></span>
							</div>
							<div className="dash-widgetcontent">
								<h5><span>{currencyFormatter.format(FormData['net_revenue'])}</span> (<span>{(Math.round(FormData['net_revenue_change']))}%</span>)</h5>
								<h6>Total Net Revenue*</h6>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-sm-6 col-6">
						<div className="dash-widget dash2">
							<div className="dash-widgetimg">
								<span><img src="../../../../../../assets/img/icons/dash3.svg" alt="img"/></span>
							</div>
							<div className="dash-widgetcontent">
								<h5><span>{currencyFormatter.format(FormData['fee'])}</span> (<span>{(Math.round(Number(FormData['fee']/Number(FormData['revenue'])*100)))}%</span>)</h5>
								<h6>Total Fee*</h6>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-sm-6 col-6">
						<div className="dash-widget dash3">
                                <div className="dash-widgetimg">
                                    <span><img src="../../../../../../assets/img/icons/dash4.svg" alt="img"/></span>
                                </div>
							<div className="dash-widgetcontent">
								<h5><span>{currencyFormatter.format(Math.round(CostProfitData['total_profit']))}</span> (<span>{numberFormatter.format(Math.round(Number(CostProfitData['total_profit'])/Number(FormData['revenue'])*100))}%</span>)</h5>
								<h6>Total Profit*</h6>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-sm-6 col-6">
						<div className="dash-count">
							<div className="dash-counts">
								<h4>{numberFormatter.format(FormData['quantity'])}</h4>
								<h5>Total Units</h5>
							</div>
							<div className="dash-imgs">
								<i data-feather="user"></i> 
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-sm-6 col-6 d-flex">
						<div className="dash-count das1">
							<div className="dash-counts">
								<h4>{numberFormatter.format(FormData['cnr_quantity'])}</h4>
								<h5>Total CnR* Units</h5>
							</div>
							<div className="dash-imgs">
								<i data-feather="user-check"></i> 
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-sm-6 col-6 d-flex">
						<div className="dash-count das2">
							<div className="dash-counts">
								<h4>{currencyFormatter.format(FormData['cnr_revenue'])}</h4>
								<h5>Total CnR Revenue</h5>
							</div>
							<div className="dash-imgs">
								<i data-feather="file-text"></i>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-sm-6 col-6 d-flex">
						<div className="dash-count das3">
							<div className="dash-counts">
								<h4>{currencyFormatter.format(CostProfitData['total_cost'])}</h4>
								<h5>Total Cost*</h5>
							</div>
							<div className="dash-imgs">
								<i data-feather="file"></i>  
							</div>
						</div>
					</div>
				</div>
				{/* <!-- Button trigger modal --> */}

				<div className="row">
					<div className="col-lg-7 col-sm-12 col-12 d-flex">
						<div className="card flex-fill">
							<div className="card-header pb-0 d-flex justify-content-between align-items-center">
								<h5 className="card-title mb-0">Sales</h5>
								
							</div>
							<div className="card-body">
								{/* <div id="sales_charts"></div> */}
                                <Chart
                                    options={apexChartDualOptions('sales-trending-data',[SalesTrendingData].map(x => x.map(a => (a[0]))).flat(2), 'Sales', 'Quantity')}
                                    // options={apexChartOptions('sales-trending-data',xaxis)}
                                    series={apexChartSeries('Revenue',  [SalesTrendingData].map(x => x.map(a => (a[1]))).flat(2), "Quantity", [SalesTrendingData].map(x => x.map(a => (a[2]))).flat(2))}
                                    type="line"
                                    width="100%"
                                    height="100%"
                                />
							</div>
						</div>
					</div>
					<div className="col-lg-5 col-sm-12 col-12 d-flex">
						<div className="card flex-fill">
							<div className="card-header pb-0 mb-0 d-flex justify-content-between align-items-center">
								<h4 className="card-title mb-0">DC / JHB</h4>
							</div>
							<div className="card-body pb-0 mb-0">
                                <div className='row'>
                                    <div className="col-lg-6 col-sm-6 col-6 d-flex">
                                        <div className="dash-count das2">
                                            <div className="dash-counts">
                                                <h4>{currencyFormatter.format(JHBData['revenue'])}</h4>
                                                <h5>Total Revenue</h5>
                                            </div>
                                            <div className="dash-imgs">
                                                <i data-feather="user"></i> 
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-6 d-flex">
                                        <div className="dash-count">
                                            <div className="dash-counts">
                                                <h4>{numberFormatter.format(JHBData['quantity'])}</h4>
                                                <h5>Total Units</h5>
                                            </div>
                                            <div className="dash-imgs">
                                                <i data-feather="user"></i> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
							</div>
							<div className="card-header pb-0 d-flex justify-content-between align-items-center">
								<h4 className="card-title mb-0">DC / CPT</h4>
								{/* <div className="dropdown">
									<a href="#" data-bs-toggle="dropdown" aria-expanded="false" className="dropset">
										<i className="fa fa-ellipsis-v"></i>
									</a>
									<ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
										<li>
											<a href="productlist.html" className="dropdown-item">Product List</a>
										</li>
										<li>
											<a href="addproduct.html" className="dropdown-item">Product Add</a>
										</li>
									</ul>
								</div> */}
							</div>
							<div className="card-body">
                                <div className='row'>
                                    <div className="col-lg-6 col-sm-6 col-6 d-flex">
                                        <div className="dash-count das2">
                                            <div className="dash-counts">
                                                <h4>{currencyFormatter.format(CPTData['revenue'])}</h4>
                                                <h5>Total Revenue</h5>
                                            </div>
                                            <div className="dash-imgs">
                                                <i data-feather="user"></i> 
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-6 d-flex">
                                        <div className="dash-count">
                                            <div className="dash-counts">
                                                <h4>{numberFormatter.format(CPTData['quantity'])}</h4>
                                                <h5>Total Units</h5>
                                            </div>
                                            <div className="dash-imgs">
                                                <i data-feather="user"></i> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
							</div>
						</div>
					</div>
				</div>
				<div className="card mb-0">
					<div className="card-body">
                        <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                            <h4 className="card-title">Products</h4>
                            <div className="graph-sets">
                                <div className="dropdown">
                                    <select className="form-select col-4" id="pageSize" value={PageSize} onChange={(e)=>{props.onPageSizeChange(e)}} aria-label="Range">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
						<div className="table-responsive dataview">
							<table className="table datatable ">
								<thead>
									<tr>
										<th>Product Name</th>
										{/* <th>Stock</th> */}
										<th>Total</th>
										<th>Cost</th>
										<th>Profit</th>
										<th>PpS</th>
										<th>PpC</th>
									</tr>
								</thead>
								<tbody>
                                    {
                                        ProductData.map(
                                            (key, i)=>{
                                                return(
                                                    <>                                                        
                                                        <tr>
                                                            <td className="productimgname">
                                                                <a className="product-img" href="productlist.html">
                                                                    <img src={key.image_url} alt="product"/>
                                                                </a>
                                                                <a href="#">{key.product_title}</a>
                                                            </td>
                                                            {/* <td>
                                                                {key.stock_at_takealot_total ? Number(key.stock_at_takealot_total)> 10 ?
                                                                <>
                                                                    <span className="">
                                                                        {key.stock_at_takealot_total}
                                                                    </span>
                                                                </>
                                                                
                                                                : 
                                                                <span className="">
                                                                        {key.stock_at_takealot_total}
                                                                </span> : <></>
                                                                }
                                                            </td> */}
                                                            <td>
                                                                <span>
                                                                    {currencyFormatter.format(key.sales)}
                                                                </span><br/>
                                                                <small className="text-muted">{numberFormatter.format(key.units)} Units</small>
                                                            </td>
                                                            <td>
                                                                <span>
                                                                    {key.cost ? currencyFormatter.format(key.cost) : currencyFormatter.format(0)}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span>
                                                                    { currencyFormatter.format(key.sales - key.cost)}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span>
                                                                    {
                                                                    key.sales ? 
                                                                    
                                                                        Number(Math.round(Number((key.sales - key.cost)/key.sales)*100),2) < 5 ?
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.sales)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        : Number(Math.round(Number((key.sales - key.cost)/key.sales)*100),2)> 5 && Number(Math.round(Number((key.sales - key.cost)/key.sales)*100),2) < 10 ? 
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.sales)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        : Number(Math.round(Number((key.sales - key.cost)/key.sales)*100),2)> 10 && Number(Math.round(Number((key.sales - key.cost)/key.sales)*100),2) < 20 ? 
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.sales)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        : Number(Math.round(Number((key.sales - key.cost)/key.sales)*100),2)> 20 ? 
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.sales)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        :
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(0)}%
                                                                        </span>
                                                                        </> 
                                                                    : 
                                                                    <>
                                                                        <span className="">
                                                                        {numberFormatter.format(100)}%
                                                                        </span>
                                                                    </>
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span>
                                                                    {
                                                                    key.sales ? 
                                                                        key.cost == 0 ?
                                                                        <span className="">
                                                                            {numberFormatter.format(0)}%
                                                                        </span>
                                                                        :
                                                                        Number(Math.round(Number((key.sales - key.cost)/key.cost)*100),2) < 5 ?
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.cost)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        : Number(Math.round(Number((key.sales - key.cost)/key.cost)*100),2)> 5 && Number(Math.round(Number((key.sales - key.cost)/key.cost)*100),2) < 10 ? 
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.cost)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        : Number(Math.round(Number((key.sales - key.cost)/key.cost)*100),2)> 10 && Number(Math.round(Number((key.sales - key.cost)/key.cost)*100),2) < 20 ? 
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.cost)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        : Number(Math.round(Number((key.sales - key.cost)/key.cost)*100),2)> 20 ? 
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(Math.round(Number((key.sales - key.cost)/key.cost)*100),2)}%
                                                                        </span>
                                                                        </>
                                                                        :
                                                                        <>
                                                                        <span className="">
                                                                            {numberFormatter.format(0)}%
                                                                        </span>
                                                                        </> 
                                                                    : 
                                                                    
                                                                    <>
                                                                        <span className="">
                                                                        {numberFormatter.format(100)}%
                                                                        </span>
                                                                    </>
                                                                    }
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            }
                                        )
                                    }
									
								</tbody>
							</table>
                            <br/>
                            <div className='pagination justify-content-center'>
                                {
                                    TotalProducts> 0 ?
                                        <MainDashboardPagination  totalRecords={TotalProducts} pageLimit={Number(PageSize)} paginationDate={CurrentDate} onPageChanged={LoadDayProductSalesList}  />
                                    : <></>
                                }
                            </div>
						</div>
					</div>
				</div>
			</div>
        </>
    )
}

const mapStateToProps = state => ({
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
})

export default connect(mapStateToProps)(DayDashboard)